export const IS_DATA_LOADING = "IS_DATA_LOADING";
export const OPEN_LOGIN = "OPEN_LOGIN";
export const GET_GLOBAL_SETTINGS = "GET_GLOBAL_SETTINGS";
export const GET_OFFER_BANNER = "GET_OFFER_BANNER";
export const GET_OFFER_PRODUCTS = "GET_OFFER_PRODUCTS";
export const GET_GLOBAL_CATEGORIES = "GET_GLOBAL_CATEGORIES";
export const GET_GLOBAL_PRODUCT_CATEGORY_INDEX_PAGE = "GET_GLOBAL_PRODUCT_CATEGORY_INDEX_PAGE";
export const GET_GLOBAL_FAVOURITE_LISTS = "GET_GLOBAL_FAVOURITE_LISTS";